import React from 'react';
import TherapySubTitle from 'components/therapy-subtitle/therapy-subtitle';
import { Grid } from '@mui/material';
import { Field } from 'redux-form';
import { renderTextArea } from 'components/form/field/redux-field';
import { nameOfFactory } from 'utils/types-util';
import { IDischargeInfoFormFields } from '../interfaces/IProps';

const nameOfFormFields = nameOfFactory<IDischargeInfoFormFields>();

export const DischargeInfo: React.FC = (): JSX.Element => {
  const rowsNumber = 3;
  const MAX_LENGTH_INPUT = 300;

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TherapySubTitle label="Summary of services provided:" />
          <Field
            name={nameOfFormFields('summaryOfServices')}
            label=""
            component={renderTextArea}
            placeholder="Add details here"
            rowsNumber={rowsNumber}
            validate={[]}
            width="100%"
            cpInputProperties={{
              maxLength: MAX_LENGTH_INPUT,
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <TherapySubTitle label="Response to Therapy/Progress towards goals" />
          <Field
            name={nameOfFormFields('responseToTherapy')}
            label=""
            component={renderTextArea}
            placeholder="Add details here"
            rowsNumber={rowsNumber}
            validate={[]}
            width="100%"
            cpInputProperties={{
              maxLength: MAX_LENGTH_INPUT,
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <TherapySubTitle label="Ongoing needs unable to be met" />
          <Field
            name={nameOfFormFields('ongoingNeeds')}
            label=""
            component={renderTextArea}
            placeholder="Add details here"
            rowsNumber={rowsNumber}
            validate={[]}
            width="100%"
            cpInputProperties={{
              maxLength: MAX_LENGTH_INPUT,
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <TherapySubTitle label="Instructions or referral information given to patient" />
          <Field
            name={nameOfFormFields('instructions')}
            label=""
            component={renderTextArea}
            placeholder="Add details here"
            rowsNumber={rowsNumber}
            validate={[]}
            width="100%"
            cpInputProperties={{
              maxLength: MAX_LENGTH_INPUT,
            }}
          />
        </Grid>
      </Grid>
    </>
  );
};
